import { css } from '@emotion/css';

export const dropdownContainerStyles = css`
  :only-child {
    padding-inline-end: 0.6rem;
  }
`;
